import { render, staticRenderFns } from "./ProductContainer.vue?vue&type=template&id=1981a050&scoped=true"
import script from "./ProductContainer.vue?vue&type=script&lang=js"
export * from "./ProductContainer.vue?vue&type=script&lang=js"
import style0 from "./ProductContainer.vue?vue&type=style&index=0&id=1981a050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1981a050",
  null
  
)

export default component.exports